import React from 'react'

import FeatureBlock from '@/components/feature-block'
import type {LegalPageGdprQuery} from '@/graphql-types'
import handleNoPrismicData from '@/utils/handle-no-prismic-data'
import RichText from '@helios/shared/components/rich-text'
import {Section} from '@helios/shared/styles/grid'

interface Props {
    content: LegalPageGdprQuery['prismicLegalPageGdpr']['data']
}

const LegalGdprContent = ({content}: Props) => {
    if (!content) {
        return handleNoPrismicData()
    }
    return (
        <>
            {content.sections.map((gdprSection, i) => {
                return (
                    <Section key={`${gdprSection.section_title}-${i}`}>
                        <FeatureBlock
                            title={gdprSection.section_title}
                            image={gdprSection.section_image}
                            mirrored={gdprSection.inverse}
                        >
                            <RichText content={gdprSection.section_content.richText} />
                        </FeatureBlock>
                    </Section>
                )
            })}
        </>
    )
}

export default LegalGdprContent
